var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.472961 14.4396C0.472961 21.3267 5.50284 27.053 12.0804 28.2138L12.158 28.1517C12.132 28.1466 12.106 28.1415 12.08 28.1363V18.3087H8.59774V14.4396H12.08V11.3443C12.08 7.86203 14.3241 5.92746 17.4968 5.92746C18.5027 5.92746 19.5861 6.08222 20.5921 6.23699V9.7966H18.8123C17.1099 9.7966 16.7229 10.6478 16.7229 11.7312V14.4396H20.4373L19.8182 18.3087H16.7229V28.1363C16.6971 28.1415 16.6713 28.1466 16.6455 28.1515L16.7234 28.2138C23.3009 27.053 28.3308 21.3267 28.3308 14.4396C28.3308 6.77875 22.0628 0.510742 14.4019 0.510742C6.74097 0.510742 0.472961 6.77875 0.472961 14.4396Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.b4b8fc2d340b2cb82040aefc4e56abc3.svg";
export { ForwardRef as ReactComponent };